import {
    FETCH_GEOJSON_REQUEST,
    FETCH_GEOJSON_SUCCESS,
    FETCH_GEOJSON_FAILURE,
  } from "../actions/geojsonActions";
  
  const initialState = {
    data: null,
    loading: false,
    error: null,
  };
  
  const geojsonReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GEOJSON_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_GEOJSON_SUCCESS:
        return { ...state, loading: false, data: action.payload };
  
      case FETCH_GEOJSON_FAILURE:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default geojsonReducer;
  